import React, { useEffect, useRef, useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import useAuth from "../../../../../components/hooks/useAuth";
import Loader from "../../../../../components/Loader";

const ModalAlterarGrupo = ({
  setStModalAlterarGrupo, group_id, loadGroupRequest
}) => {


  const [groupName, setGroupName] = useState("");
  const [groupDescription, setGroupDescription] = useState("");
  const [maxMembers, setMaxMember] = useState(256);
  const [restrictAnnouncementtype, setRestrictAnnouncementtype] = useState(false);
  const [ephemeralHours, setEphemeralHours] = useState(0);


  const [pictureBase64, setPictureBase64] = useState(null); // pode ser url ou cor


  const [abaModal, setAbaModal] = useState("detalhes"); // "detalhes" ou "admins"

  const inputCapaRef = useRef(null);
  const { sidebarOpen, getApi, postApi } = useAuth();

  const [loadingOperation, setLoadingOperation] = useState(false);
  const [loading, setLoading] = useState(true);

  const [position, setPosition] = useState(0);


  useEffect(() => {


    if (group_id) {
      loadGroupShowRequest();

    }

  }, [group_id]);


  const loadGroupShowRequest = async () => {

    setLoading(true);
    try {
      let response = await postApi("/api/v1/campaign/groups/show/" + group_id, {
      });

      setGroupName(response.name);
      setGroupDescription(response.description);
      setMaxMember(response.max_members);
      setRestrictAnnouncementtype(response.restrict_announcement_type == 'announcement' ? true : false);
      setEphemeralHours(response.ephemeral_hours);
      setPictureBase64(response.picture_url)
      setPosition(response.position)
      if (!response.id) {

        window.alert(response.error.toString());
      }

    } catch (error) {
      window.alert("Erro ao processar associação:", error);
      // Aqui você pode tratar o erro (ex: toast de aviso)
    } finally {

      setLoading(false);
    }
  }




  const editGroupRequest = async () => {


    if (maxMembers > 1000) {
      alert("O limite de pessoas em grupo é de até 1000");
      return;
    }
    setLoadingOperation(true);
    try {
      let response = await postApi("/api/v1/campaign/groups/edit/" + group_id, {
        'name': groupName,
        'description': groupDescription,
        'max_members': maxMembers,
        'restrict_announcement_type': restrictAnnouncementtype ? "announcement" : "not_announcement",
        'picture_base64': pictureBase64,
        'invite_enabled': true,
        'ephemeral_hours': ephemeralHours,
        'position': parseInt(position)
      });

      if (!response.id) {

        if (response.errors.max_members) {
          window.alert(response.errors.max_members.toString());
        }
      } else {
        window.alert("Os dados foram salvos com sucesso");
      }


    } catch (error) {
      window.alert("Erro ao processar associação:", error);
      // Aqui você pode tratar o erro (ex: toast de aviso)
    } finally {
      loadGroupShowRequest();
      setLoadingOperation(false);
      loadGroupRequest();
      //setStModalAlterarGrupo(null)
    }


  }

  if (!group_id) return null;



  return (
    <div style={{
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0,0,0,0.4)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

    }}>
      {loading &&
        <div style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(0,0,0,0.4)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}><Loader /></div>
      }



      <div style={{
        background: "#fff",
        borderRadius: 18,
        padding: 0,
        minWidth: 320,
        maxWidth: 400,
        width: "95vw",
        maxHeight: "90vh",
        boxShadow: "0 2px 16px rgba(0,0,0,0.18)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
        visibility: !loading
      }}>
        <h2 style={{
          color: "#005c53",
          margin: "24px 0 0 0",
          fontWeight: "bold",
          width: "100%",
          textAlign: "center"
        }}>Criação de grupos</h2>
        {/* Círculo da capa */}
        <div style={{
          position: "relative",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          margin: "18px 0 0 0"
        }}>
          <div style={{
            width: 110,
            height: 110,
            borderRadius: "50%",
            background: pictureBase64 ? `url(${pictureBase64}) center/cover` : "#51a197",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 38,
            color: "#fff",
            fontWeight: "bold",
            overflow: "hidden",
            position: "relative"
          }}>
            {!pictureBase64 && "G"}
            {/* Ícone editar */}
            <button
              style={{
                position: "absolute",
                bottom: 8,
                right: 44,
                background: "#fff",
                border: "2px solid #51a197",
                borderRadius: "50%",
                width: 34,
                height: 34,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 1px 4px rgba(0,0,0,0.10)"
              }}
              title="Editar capa"
              onClick={() => inputCapaRef.current && inputCapaRef.current.click()}
            >
              <FaEdit color="#51a197" size={18} />
            </button>
            {/* Input file escondido */}
            <input
              type="file"
              accept="image/*"
              ref={inputCapaRef}
              style={{ display: "none" }}
              onChange={e => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onload = ev => { setPictureBase64(ev.target.result); };

                  reader.readAsDataURL(file);
                }
              }}
            />
            {/* Ícone excluir */}
            <button
              style={{
                position: "absolute",
                bottom: 8,
                right: 0,
                background: "#fff",
                border: "2px solid #e74c3c",
                borderRadius: "50%",
                width: 34,
                height: 34,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 1px 4px rgba(0,0,0,0.10)"
              }}
              title="Excluir capa"
              onClick={() => setPictureBase64(null)}
            >
              <FaTrash color="#e74c3c" size={18} />
            </button>
          </div>
        </div>
        {/* Conteúdo rolável */}
        <div style={{
          width: "100%",
          padding: "24px 24px 16px 24px",
          overflowY: "auto",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          boxSizing: "border-box"
        }}>
          {/* Abas do modal */}
          <div style={{
            width: "100%",
            display: "flex",
            borderBottom: "1px solid #e0e0e0",
            marginBottom: 18,
            marginTop: 12
          }}>
            <button
              onClick={() => setAbaModal("detalhes")}
              style={{
                flex: 1,
                background: "none",
                border: "none",
                borderBottom: abaModal === "detalhes" ? "3px solid #51a197" : "none",
                color: abaModal === "detalhes" ? "#51a197" : "#333",
                fontWeight: "bold",
                fontSize: 16,
                padding: "10px 0",
                cursor: "pointer"
              }}
            >
              Detalhes do Grupo
            </button>

          </div>
          {/* Conteúdo das abas */}
          {abaModal === "detalhes" && (
            <div style={{ width: "100%" }}>
              <label style={{ fontWeight: "bold", color: "#333", marginBottom: 4 }}>Nome do grupo</label>
              <input
                type="text"
                value={groupName}
                onChange={e => setGroupName(e.target.value)}
                placeholder="Digite o nome do grupo"
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  borderRadius: 8,
                  border: "1px solid #51a197",
                  fontSize: 16,
                  marginBottom: 16,
                  boxSizing: "border-box"
                }}
              />

              {/* Apenas admins enviam mensagem ao grupo */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontWeight: "bold", color: "#333", marginBottom: 8, display: "block" }}>
                  Apenas admins enviam mensagem ao grupo
                </label>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <label style={{ position: "relative", display: "inline-block", width: 50, height: 24 }}>
                    <input
                      type="checkbox"
                      style={{ opacity: 0, width: 0, height: 0 }}
                      onChange={e => setRestrictAnnouncementtype(e.target.checked)}
                      checked={restrictAnnouncementtype}
                    />
                    <span style={{
                      position: "absolute",
                      cursor: "pointer",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: restrictAnnouncementtype == 'announcement' ? "#51a197" : "#ccc",
                      borderRadius: 24,
                      transition: "0.4s"
                    }}></span>
                    <span style={{
                      position: "absolute",
                      content: '""',
                      height: 18,
                      width: 18,
                      left: restrictAnnouncementtype == 'announcement' ? 28 : 4,
                      bottom: 3,
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      transition: "0.4s"
                    }}></span>
                  </label>
                </div>
              </div>


              <label style={{ fontWeight: "bold", color: "#333", marginBottom: 4 }}>Descrição do grupo</label>
              <textarea
                value={groupDescription}
                onChange={e => setGroupDescription(e.target.value)}
                placeholder="Digite a descrição do grupo"
                rows={6}
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  borderRadius: 8,
                  border: "1px solid #51a197",
                  fontSize: 16,
                  resize: "vertical",
                  minHeight: 120,
                  marginBottom: 16,
                  boxSizing: "border-box"
                }}
              />
              {/* Início da contagem */}
              <label style={{ fontWeight: "bold", color: "#333", marginBottom: 4, width: "100%" }}>
                Início da contagem
              </label>

              <input
                type="number"
                min={0}
                value={position}
                onChange={e => setPosition(e.target.value)}
                placeholder="Digite o início da contagem"
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  borderRadius: 8,
                  border: "1px solid #51a197",
                  fontSize: 16,
                  boxSizing: "border-box"
                }}
              />
              <small style={{
                marginBottom: 18
              }}>A posição 1 tornará o grupo padrão na criação automática de grupos.</small>
              <br></br>

              <label style={{ fontWeight: "bold", color: "#333", marginBottom: 4, marginTop: 5 }}>Limite de pessoas</label>
              <input
                type="number"
                value={maxMembers}
                onChange={e => setMaxMember(e.target.value)}
                placeholder="Digite o limite de pessoas"
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  borderRadius: 8,
                  border: "1px solid #51a197",
                  fontSize: 16,
                  marginBottom: 16,
                  boxSizing: "border-box"
                }}
              />

              <label style={{ fontWeight: "bold", color: "#333", marginBottom: 4 }}>Mensagem Temporária</label>
              <select
                value={ephemeralHours}
                onChange={(e) => setEphemeralHours(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  borderRadius: 8,
                  border: "1px solid #51a197",
                  fontSize: 16,
                  marginBottom: 16,
                  boxSizing: "border-box"
                }}
              >
                <option value={0}>Desativado</option>
                <option value={86400}>24h</option>
                <option value={604800}>7 dias</option>
                <option value={7776000}>90 dias</option>
              </select>



              <div style={{
                display: "flex",
                gap: 16,
                marginTop: 12,
                width: "100%",
                justifyContent: "flex-end"
              }}>
                <button
                  onClick={e => editGroupRequest()}
                  disabled={loadingOperation}
                  style={{
                    background: "#51a197",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    padding: "10px 28px",
                    fontWeight: "bold",
                    fontSize: 16,
                    cursor: "pointer"
                  }}
                >
                  Salvar
                </button>
                <button
                  style={{
                    background: "#e0e0e0",
                    color: "#005c53",
                    border: "none",
                    borderRadius: 8,
                    padding: "10px 28px",
                    fontWeight: "bold",
                    fontSize: 16,
                    cursor: "pointer"
                  }}
                  disabled={loadingOperation}
                  onClick={() => setStModalAlterarGrupo(null)}
                >
                  Cancelar
                </button>
              </div>

              {loadingOperation && <Loader />}
            </div>
          )}

        </div>
      </div>

    </div>
  );
};

export default ModalAlterarGrupo;